import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import CheckIcon from '@mui/icons-material/Check';
import PeopleItem from '../../PeopleItem';
const PREFIX = 'PeopleListItem';
const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  check: `${PREFIX}-check`
};
const Root = styled('button')(/* istanbul ignore next */({
  theme: {
    spacing,
    palette
  }
}) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    padding: spacing(2, 1),
    margin: 0,
    textAlign: 'left',
    background: 'transparent',
    width: '100%',
    border: 'none',
    alignItems: 'center',
    '&:hover, &:focus': {
      cursor: 'pointer',
      background: palette.background.alternative
    }
  },
  [`& .${classes.item}`]: {
    flexGrow: 1,
    width: '100%',
    overflow: 'hidden'
  },
  [`& .${classes.check}`]: {
    display: 'flex',
    color: palette.brand.main
  }
}));
export default function PeopleListItem(t0) {
  const $ = _c(11);
  const {
    userId,
    userName,
    subHeading,
    avatarUrl: t1,
    isSelected: t2,
    onClick: t3
  } = t0;
  const avatarUrl = t1 === undefined ? null : t1;
  const isSelected = t2 === undefined ? false : t2;
  const onClick = t3 === undefined ? _temp : t3;
  let t4;
  if ($[0] !== avatarUrl || $[1] !== subHeading || $[2] !== userId || $[3] !== userName) {
    t4 = <span className={classes.item}><PeopleItem userId={userId} userName={userName} subHeading={subHeading} avatarUrl={avatarUrl} /></span>;
    $[0] = avatarUrl;
    $[1] = subHeading;
    $[2] = userId;
    $[3] = userName;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isSelected) {
    t5 = isSelected && <span className={classes.check}><CheckIcon color="inherit" /></span>;
    $[5] = isSelected;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== onClick || $[8] !== t4 || $[9] !== t5) {
    t6 = <Root type="button" className={classes.root} onClick={onClick}>{t4}{t5}</Root>;
    $[7] = onClick;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp() {}